import styled from "styled-components";
import { IconButton, Icon } from "@evergis/ui";
import { Controls } from "../../styled";

export const EditIconButton = styled(IconButton)`
  ${Icon} {
    width: 2rem;
    display: inline-flex;

    &:after {
      left: 0.5rem;
    }

    + span {
      margin-left: 0;
      font: ${({ theme: { fonts } }) => fonts.description};
      line-height: 1rem;
    }
  }
`;

export const CopyIconButton = styled(EditIconButton)`
  width: auto;

  ${Icon} {
    margin-left: 0;
  }
`;

export const HandBookControlsContainer = styled(Controls)`
  align-items: center;

  span[kind="search"] {
    margin-left: 0.5rem;

    :after {
      color: ${({ theme: { palette } }) => palette.iconDisabled};
    }
  }

  input[type="text"] {
    background-color: transparent;
    border: 0;
  }
`;
